import React, { useEffect, useState } from 'react';
import { CssBaseline, Box, Container } from '@material-ui/core';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom'
import { ThemeProvider, makeStyles } from '@material-ui/core/styles';
import { theme } from '../config/theme.js';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Copyright from '../components/Copyright.js'
import Banners from '../single-page/components/Banners.js'
import SignInOrUp from './SignInOrUp.js'
import Termos from '../single-page/pages/Termos.js'
import Faq from '../single-page/pages/Faq.js'
import ResetPassword from './ResetPassword.js'
import RequestPasswordReset from './RequestPasswordReset.js'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../public/styles/main.scss";
import Footer from '../components/Footer.js'
import Politicas from '../single-page/pages/Politicas.js'
import { flushPending, pushDataLayer } from '../single-page/utils';
import logo from '../images/cap_logo.png';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '800px',
    '@media(max-width: 1440px)': {
      minHeight: '600px',
    },
  },
  banner: {
    padding: '0px',
    textAlign: '-webkit-center'
  },
  '& .MuiAppBar-positionFixed': {
    position: 'relative'
  },
  footer: {
    width: '100%',
    position: 'relative',
    bottom: 0,
    backgroundColor: '#1A3F1B',
    marginTop: '64px',
    '@media(max-width: 1280px)': {
      position: 'relative'
    },
    '@media(max-width: 600px)': {
      marginTop: '64px',
    }
  }
}));

export default function Public({ flash, global_schema: globalSchema = { current_customer: {} }, influencer }) {
  const classes = useStyles();
  useEffect(() => {
    flushPending(pushDataLayer);

    // Atualiza o titulo do documento usando a API do browser
    if (flash.notice) {
      toast.info(flash.notice);
    }
    if (flash.notice) {
      toast.warning(flash.alert);
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <ToastContainer autoClose={8000} />
        <CssBaseline />
        <AppBar style={{ position: 'relative' }}>
          <Toolbar style={{ justifyContent: 'center', color: '#fff', backgroundColor: '#2A5B2C' }}>
            <a href="/">
              <img src={logo} alt="" title={"icone"} height="50" style={{margin: '30px 0'}} />
            </a>
          </Toolbar>
        </AppBar>
        <Container className={classes.banner} component="main" maxWidth="xl">
          <Route exact path="/public/termos">
            <Termos content={globalSchema.termos} />
          </Route>
          <Route exact path="/public/politicas">
            <Politicas content={globalSchema.politicas} />
          </Route>
          <Route exact path="/public/faq">
            <Faq content={globalSchema.faq} />
          </Route>
        </Container>
        <Container className={classes.paper} maxWidth="xs">
          <Route exact path={["/public/sign_in"]}>
            <SignInOrUp />
          </Route>
          <Route exact path={["/", "/public", "/public/sign_up"]}>
            <SignInOrUp />
          </Route>
          <Route exact path={["/public/sign_in_or_up"]}>
            <SignInOrUp />
          </Route>
          <Route exact path="/public/reset_password">
            <ResetPassword />
          </Route>
          <Route exact path="/public/request_password_reset">
            <RequestPasswordReset />
          </Route>
        </Container>
        {navigator.userAgent != "app-ios" ? (
          <Box className={classes.footer}>
            <Footer />
          </Box>) : ("")
        }
      </Router>
    </ThemeProvider>
  );
}
